import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { AccommodationDetail } from './components/AccommodationDetail';
import { UserProfileProvider } from './context/UserProfileContext';
export function AppRouter() {
  return <BrowserRouter data-id="element-11">
      <UserProfileProvider data-id="element-12">
        <Routes data-id="element-13">
          <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
          <Route path="/accommodation/:id" element={<AccommodationDetail data-id="element-17" />} data-id="element-16" />
        </Routes>
      </UserProfileProvider>
    </BrowserRouter>;
}